import { Outlet, useNavigate } from "react-router-dom";
import withUserData from "../../HOC/withUserData";
import { redirectAfterDelay } from "../../utils/utils";

const SigninIndex = ({ loggedInAsGuest = true, isLoggedIn }) => {
  const navigate = useNavigate();

  if (!loggedInAsGuest && isLoggedIn) {
    redirectAfterDelay('/', 0);
  }
  
  return (
    <div className="bg-white">
      <Outlet />
    </div>
  );
};

export default withUserData(SigninIndex);
